import { Partner } from "./types";

export const cnPartners: readonly Partner[] = [
  {
    id: "wcp",
    link: [
      { info: "wcp_tel_1", label: "95017", href: "" },
      {
        info: "wcp_tel_2",
        label: "(+86)571-95017",
        href: "tel:+86-571-95017",
      },
    ],
    image: "wcp.png",
    opTime: "wcp_op_time",
    width: 90,
    height: 28,
  },
  {
    id: "upi",
    link: [
      { info: "upi_tel_1", label: "95516", href: "" },
      {
        info: "upi_tel_2",
        items: [
          { label: "(+86)21-95516", href: "tel:+86-21-95516" },
          { label: "(+86)21-20556900", href: "tel:+86-21-20556900" },
          { label: "(+86)21-52295600", href: "tel:+86-21-52295600" },
        ],
      },
    ],
    image: "upi.png",
    opTime: "upi_op_time",
    width: 90,
    height: 90,
  },
];
